<template>
  <div class="methods">
    <div class="banner" v-if="isMobile" :style="{ backgroundImage: `url(${datalist.mbanner})` }">
      <!-- <img :src="datalist.banner" alt=""> -->
        <h1>{{ datalist.name }}</h1>
        <p>{{ datalist.description }}</p>
        <div class="inner_btn">
          <button @click="goToContact(2)" class="inner-le">Eco-cooperation</button>
        <button @click="goToContact(3)" class="inner-ri">Contact us</button>
        </div>
    </div>
    <div class="banner" v-else :style="{ backgroundImage: `url(${datalist.banner})` }">
      <!-- <img :src="datalist.banner" alt=""> -->
        <h1>{{ datalist.name }}</h1>
        <p>{{ datalist.description }}</p>
        <div class="inner_btn">
          <button @click="goToContact(2)" class="inner-le">Eco-cooperation</button>
        <button @click="goToContact(3)" class="inner-ri">Contact us</button>
        </div>
    </div>
    <div class="sol-main" v-for="item in datalist.items" :key="item.id">
      <div class="sol-h" v-if="item.itemType===1">
        <div class="box"></div>
        <h1>{{ item.itemContent }}</h1>
      </div>
      <div class="sol-p" v-if="item.itemType===2">
        <p>{{ item.itemContent }}</p>
      </div>
      <ul v-else-if="item.itemType===7" class="dot-list">
        <li v-for="(listItem, index) in parseListContent(item.itemContent)" :key="index">
          {{ listItem }}
        </li>
      </ul>
      <!-- 单图片显示 -->
      <div v-else-if="item.itemType===4" class="single-image">
        <img :src="item.itemContent" alt="单图片" class="single-img" />
      </div>
      <!-- 多图片显示 -->
      <div v-else-if="item.itemType===5" class="multiple-images">
        <div class="image-gallery">
          <img 
            v-for="(imageUrl, index) in parseImageContent(item.itemContent)" 
            :key="index" 
            :src="imageUrl" 
            :alt="`图片${index + 1}`" 
            class="gallery-img"
          />
        </div>
      </div>
    </div>

    <div class="detail_main" v-if="getCoreFeatures().length > 0">
  <div class="sys-detail">
    <div class="sys-title">
    </div>
    <div class="sys-card" v-if="isMobile">
      <el-row :gutter="20">
        <el-col :span="24" v-for="(feature, index) in getCoreFeatures()" :key="index">
          <div class="grid-content ep-bg-purple">
            <h3>{{ feature.title }}</h3>
            <ul>
              <li v-for="(item, itemIndex) in feature.valueList" :key="itemIndex">
                <p>{{ item }}</p>
              </li>
            </ul>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="sys-card" v-else>
      <el-row :gutter="20">
        <el-col :span="6" v-for="(feature, index) in getCoreFeatures()" :key="index">
          <div class="grid-content ep-bg-purple">
            <h3>{{ feature.title }}</h3>
            <ul>
              <li v-for="(item, itemIndex) in feature.valueList" :key="itemIndex">
                <p>{{ item }}</p>
              </li>
            </ul>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
    </div>

    <div class="success_outer">
      <div class="success">
      <h1>Success cases</h1>
      <div class="succ-box" v-if="isMobile">
        <el-row :gutter="20">
          <el-col :span="24" v-for="item in case_data" :key="item.id" style="height: 18em;">
            <div class="grid-content ep-bg-purple">
              <div class="grid-top">
                <img :src="item.thumbnail" alt="">
              </div>
              <div class="grid-bottom" @click="goto_case(item.id)">
                <h3>{{ item.name }}</h3>
                <p>{{ item.description }}</p>
                <el-button>MORE</el-button>
              </div>
              </div>
            </el-col>
            </el-row>
      </div>
      <div class="succ-box" v-else>
        <el-row :gutter="20">
          <el-col :span="8" v-for="item in case_data" :key="item.id" style="height: 25em;">
            <div class="grid-content ep-bg-purple">
              <div class="grid-top">
                <img :src="item.thumbnail" alt="">
              </div>
              <div class="grid-bottom">
                <h3>{{ item.name }}</h3>
                <p>{{ item.description }}</p>
                <el-button @click="goto_case(item.id)">MORE</el-button>
              </div>
              </div>
            </el-col>
            </el-row>
      </div>
    </div>
    </div>
    
  </div>
</template>

<script setup name="SulMethods">
import { onMounted,ref,onUnmounted } from 'vue'
import { useRoute,useRouter } from 'vue-router'
import { getSolutionDetail } from '../api/solution'
import { watch } from 'vue'
const route = useRoute()
const router = useRouter()
let id = route.query.id
const datalist = ref({})
const case_data=ref([])
console.log(id);
onMounted(() => {
  window.scrollTo(0, 0)
  checkMobile()
  window.addEventListener('resize', checkMobile)
  solutionrender()
})
onUnmounted(() => {
  window.removeEventListener('resize', checkMobile)
})
watch(
  () => route.query.id,
  (newId, oldId) => {
    if (newId && newId !== oldId) {
      datalist.value = {}; // 清空case_data数组
      case_data.value = []; // 清空case_data数组
      solutionrender() // 重新获取数据
    }
  },
  { immediate: true } // 立即执行一次
)
const emit = defineEmits(['scroll-to-contact'])
function goToContact(type) {
  emit('scroll-to-contact', type)
}
const parseImageContent = (content) => {
  if (!content) return [];
  if (Array.isArray(content)) {
    return content;
  }
  try {
    const parsed = JSON.parse(content);
    return Array.isArray(parsed) ? parsed : [content];
  } catch (error) {
    return content.split(',').map(url => url.trim()).filter(url => url.length > 0);
  }
};
//页面缩小，适应布局
const isMobile = ref(false)
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 1024
}
async function solutionrender() {
  const id = route.query.id;
  console.log(id);
  const res = await getSolutionDetail(id)
  datalist.value = res.data
  case_data.value = datalist.value.subObjects
}
function goto_case(id){
  router.push(`/en/productdetail?id=${id}`)
}
const parseListContent = (content) => {
  if (!content) return [];
  return content
    .split('\n')
    .map(item => item.trim())
    .filter(item => item.length > 0)
    .map(item => item.replace(/^[•·\-\*]\s*/, '')); // 移除开头的符号
};
const getCoreFeatures = () => {
  console.log('=== 调试核心功能数据 ===');
  console.log('datalist.value:', datalist.value);
  console.log('datalist.value.items:', datalist.value.items);
  
  if (!datalist.value.items) {
    console.log('datalist.value.items 为空，返回空数组');
    return [];
  }
  
  const coreFeatureItems = datalist.value.items.filter(item => item.itemType === 8);
  console.log('核心功能项目 (itemType === 8):', coreFeatureItems);
  
  const features = [];
  
  coreFeatureItems.forEach(item => {
    console.log('处理核心功能项:', item);
    console.log('itemContent:', item.itemContent);
    console.log('itemContent 类型:', typeof item.itemContent);
    
    try {
      // 如果 itemContent 已经是数组，直接使用
      const parsedFeatures = Array.isArray(item.itemContent) ? item.itemContent : JSON.parse(item.itemContent);
      console.log('解析后的功能数据:', parsedFeatures);
      
      parsedFeatures.forEach(feature => {
        const processedFeature = {
          title: feature.title,
          valueList: feature.valueList ? feature.valueList.split(';').filter(item => item.trim()) : []
        };
        console.log('处理后的功能项:', processedFeature);
        features.push(processedFeature);
      });
    } catch (e) {
      console.error('解析核心功能数据失败:', e);
      console.error('原始数据:', item.itemContent);
    }
  });
  
  console.log('最终返回的功能数组:', features);
  console.log('=== 调试结束 ===');
  return features;
};
</script>
  
<style scoped>
 .banner{
  overflow: hidden;
  width: 100%;
  height: 12em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color:white;
  background-color: #ddd;
  margin-bottom: 8em;
  background-size: 100% 100%;
  background-position: center;
  text-align: left;
  background-repeat: no-repeat;
}
.inner-le,.inner-ri{
  width: 10em;
  height: 2.5em;
  border-radius: 1.5em;
  font-size: 1em;
  border:transparent;
  cursor: pointer;
  margin: 1em auto;
}
.inner_btn{
  margin-left: 18%;
}
.inner-le{
  background-color: orange;
  color: white;
  margin-right: 1em;
}
.inner-ri{
  background-color: skyblue;
  color: white;
}
.banner h1,.banner p{
   width: 65%;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 1em;
  margin-left: 18%;
}
/* .inner p{
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
} */
 .detail_main {
  width: 100%;
  background-color: #F9FAFC;
  padding: 4em 0;
}

.sys-detail {
  width: 60%;
  margin: 0 auto;
}

.sys-detail .sys-title {
  text-align:left;
  margin-bottom: 3em;
}

.sys-detail .sys-title h1 {
  font-size: 2em;
  margin-bottom: 0.5em;
  color: #333;
}

.sys-detail .sys-title p {
  font-size: 1.2em;
  /* color: #666; */
}

.sys-detail .sys-card .grid-content {
  /* overflow: hidden; */
  width: 100%;
  box-shadow: 1px 1px 10px -4px #ddd;
  border-radius: 8px;
  margin-bottom: 2em;
  /* transition: transform 0.3s ease; */
}

.sys-detail .sys-card .grid-content > h3 {
  color: white;
  height: 4em;
  width: 100%;
  text-align: center;
  margin: 0;
  background-color: #6E6BF3;
  line-height: 4em;
  font-size: 1.3em;
}

.sys-detail .sys-card .grid-content > ul {
  width: 90%;
  background-color: #fff;
  min-height: 13em;
  margin: 0 auto;
  padding: 1.5em 0;
  list-style: none;
}

.sys-detail .sys-card .grid-content > ul li {
  width: 80%;
  margin: 1em auto;
}

.sys-detail .sys-card .grid-content > ul li p {
  color: #555;
  line-height: 1.6;
  margin: 0;
}
.sol-main,.success{
  width: 60%;
  height: 100%;
  margin: 2em auto;
}
.success_outer{
  overflow: hidden;
  background-color: #F9FAFC ;
}
.success{
  margin: 4em auto;
}
.success>h1{
  margin-bottom: 1em;
}
.sol-h{
  display: flex;
  align-items: center;
  width: 100%;
  height: 6em;
}
.sol-h .box{
  display: inline-block;
  width: 0.5em;
  height: 2em;
  background-color: #0073FF;
}
.sol-h h1{
  display: inline-block;
  height: 3em;
  line-height: 3em;
  margin-left: 0.5em;
}
.sol-p{
  width: 100%;
  text-indent: 2em;
  line-height: 2em;
}
.single-image {
  width: 100%;
  text-align: center;
  margin: 2em 0;
}

.single-img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

.multiple-images {
  width: 100%;
  margin: 2em 0;
}

.image-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1em;
  padding: 1em 0;
}

.gallery-img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.gallery-img:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}
.success .succ-box{
  margin-top: 4em;
}
.success .succ-box .grid-content{
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.success .succ-box .grid-content .grid-top{
  width: 100%;
  height: 40%;
}
.success .succ-box .grid-content .grid-top img{
  width: 100%;
  height: 100%;
}
.success .succ-box .grid-content .grid-bottom{
  width: 90%;
  height: 60%;
  display: flex;
  flex-direction: column;
  /* justify-content: flex-end; */
  text-align: left;
  margin: 0 1em;
}
.success .succ-box .grid-content .grid-bottom>p{
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 限制显示3行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.success .succ-box .grid-content .grid-bottom h3,.success .succ-box .grid-content .grid-bottom p{
  margin: 1em 0;
}
.success .succ-box .grid-content .grid-bottom h3{
  height: 2em;
  display: flex; 
  flex-wrap: wrap;
  align-items: flex-end;
}

.success .succ-box .grid-content .grid-bottom .el-button{
  width: 30%;
  margin: 1.5em 0;
  border:1px solid #000;
  border-radius: 0;
  color: #000;
}
.dot-list {
  margin: 1em 0;
  padding-left: 1.2em;
}
.dot-list li {
  font-weight: bold;
  list-style: disc;
  font-size: 18px;
  margin: 0.5em 0;
  line-height: 1.6;
}
@media (max-width:1024px) {
  .banner{
    height: 12em;
    margin-bottom: 1em;
    text-align: center;
  }
  .banner h1{
  font-size: 1.2em;
  margin-top: 2em;
  }
  .inner_btn{
  margin-left: 0;
  }
  .inner-le,.inner-ri{
  font-size: 0.8em;
  height: 2.5em;
}
.sol-h{
  display: flex;
  align-items: center;
  width: 100%;
  height: 1em;
}
.sol-h .box{
  display: inline-block;
  width: 0.2em;
  height: 1em;
  background-color: #0073FF;
}
.sol-h h1{
  display: inline-block;
  height: 1.2em;
  line-height: 1.2em;
  font-size: 1.2em;
  margin-left: 0.5em;
}
.sol-p{
  width: 100%;
  text-indent: 2em;
  line-height: 2em;
  font-size: 0.8em;
}
.sol-p p{
  margin-top: 2em;
}
.sol-main,.success{
  width: 88%;
  height: 100%;
  margin: 1em auto;
}
.success_outer{
  width: 100%;
  background-color:#005BAC;
}
.success_outer .success{
  text-align: center;
}
.success_outer .success>h1{
  font-size: 1.2em;
}
.success_outer .success>p{
  font-size: 0.8em;
}
.success .succ-box{
  margin-top: 1em;
}
.success .succ-box .el-col{
  margin-top: 1em;
}
.success .succ-box .grid-content{
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.success .succ-box .grid-content .grid-top{
  width: 100%;
  height: 40%;
}
.success .succ-box .grid-content .grid-top img{
  width: 100%;
  height: 100%;
}

.success .succ-box .grid-content .grid-bottom h3,.success .succ-box .grid-content .grid-bottom p{
  margin: 0;
}
.success .succ-box .grid-content .grid-bottom p{
  font-size: 0.8em;
  margin-top: 0.5em;
}
.success .succ-box .grid-content .grid-bottom h3{
  font-size: 1em;
  display: flex; 
  flex-wrap: wrap;
  align-items: flex-end;
  margin-top: 1em;
  margin-bottom: 1em;
}

.success .succ-box .grid-content .grid-bottom .el-button{
  width: 20%;
  margin: 1em 0;
  font-size: 0.8em !important;
  border-radius: 0;
  color: #000;
}
.image-gallery {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 0.5em;
  }
  
  .gallery-img {
    height: 150px;
  }
}
</style>